import React, { useEffect, useState } from "react";
import CustomerDetails from "./CustomerDetails";
import userResources from "api/userResources";
import InputField from "components/fields/InputField";

export default function Misc({
  misc,
  register,
  errors,
  clearErrors,
  watch,
  setValue,
  getValues,
  control,
  updateData,
}) {
  const [supplierData, setSupplierData] = useState([]);
  const getSuppliers = async () => {
    try {
      const response = await userResources.supplier();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setSupplierData(combinedData);
      if (updateData) {
        setValue("misc.supplier_id", Number(updateData?.misc?.supplier_id));
        setValue("misc.amount", updateData?.misc?.amount);
        setValue("misc.invoice_details", updateData?.misc?.invoice_details);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSuppliers();
  }, []);

  return (
    <section className="p-2">
      <div className="">
        <div className="mt-3 bg-[#ff4e41] p-1 text-white">
          <div className="grid grid-cols-1 items-center gap-4 sm:grid-cols-2">
            <div className="flex flex-wrap items-center gap-2">
              <div>
                <label className="md:whitespace-nowrap">Supplier:</label>
              </div>
              <div className="w-64">
                <select
                  {...register("misc.supplier_id")}
                  value={watch("misc.supplier_id")}
                  onChange={(e) => {
                    setValue("misc.supplier_id", e.target.value);
                    clearErrors("misc.supplier_id");
                  }}
                  className="w-full bg-white text-gray-900"
                >
                  <option value="">Select...</option>
                  {supplierData.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                {errors?.misc?.supplier_id && (
                  <span className="mt-1 block text-xs text-white">
                    {errors?.misc?.supplier_id?.message}
                  </span>
                )}
              </div>
            </div>
            <div className="mb-2">
              <div className="flex items-center gap-2">
                <label htmlFor="misc.amount" className="mb-1 block">
                  Amount:
                </label>
                <div className="w-64">
                  <input
                    id="misc.amount"
                    type="number"
                    placeholder="Enter Amount"
                    {...register("misc.amount", {
                      required: "Amount is required",
                      valueAsNumber: true,
                    })}
                    onChange={() => clearErrors("misc.amount")}
                    className="w-full !rounded-none bg-white !py-0 px-2 text-black outline-none"
                  />
                </div>
                {errors?.misc?.amount && (
                  <span className="text-xs text-white">
                    {errors.misc.amount.message}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="mb-2">
          <label
            htmlFor="misc.invoice_details"
            className="my-2 block text-[#ff4e41]"
          >
            Invoice Details:
          </label>
          <textarea
            id="misc.invoice_details"
            placeholder="Enter Invoice Details"
            {...register("misc.invoice_details", {
              required: "Invoice details are required",
            })}
            rows={10}
            onChange={() => clearErrors("misc.invoice_details")}
            className="w-full rounded border bg-white px-2 py-1 text-black"
          />
          {errors?.misc?.invoice_details && (
            <span className="text-sm text-red-500">
              {errors.misc.invoice_details.message}
            </span>
          )}
        </div>
      </div>
    </section>
  );
}
